'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref, header) {
  var accessToken = _ref.access_token;

  if (accessToken) {
    header('Authorization', 'Bearer ' + accessToken);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-simple-auth/lib/authorizers/oauth2Bearer.js
// module id = 695
// module chunks = 0